/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Directive, ElementRef } from "@angular/core";

@Directive({
  selector: "[appShowHidePassword]",
})
export class ShowHidePasswordDirective {
  private _shown = false;

  constructor(private el: ElementRef) {
    this.setup();
  }
  toggle(span: HTMLElement) {
    this._shown = !this._shown;
    if (this._shown) {
      this.el.nativeElement.setAttribute("type", "text");
      span.innerHTML = `<img class="eye" src="assets/icons/blueEye.svg">`;
    } else {
      this.el.nativeElement.setAttribute("type", "password");
      span.innerHTML = `<img class="eye" src="assets/icons/blueEyeOff.svg">`;
    }
  }

  setup() {
    const parent = this.el.nativeElement.parentNode;
    const currentElement = this.el.nativeElement;
    const span = document.createElement("span");
    span.className = "input-icon ws-cursor-pointer";
    span.append('fxFlex="20"');
    span.innerHTML = `<img class="eye" src="assets/icons/blueEyeOff.svg">`;
    span.addEventListener("click", (event) => {
      currentElement.focus();
      this.toggle(span);
    });
    parent.appendChild(span);
  }
}
